import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config/config';
import Footer from '../components/Footer';
import staticlogo from '../assets/images/bg_blue.svg';

const HelpContentPage = () => {
  const { mainCategoryId, parentCategoryId, childCategoryId } = useParams();
  const [contentData, setContentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [helpData, setHelpData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${config.baseURL}/get-help-page-content`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        if (result.success) {
          const mainCategories = result.data['main-categories'] || [];
          const parentCategories = result.data['parent-categories'] || [];
          const childCategories = result.data['child-categories'] || [];
          const pageSEO = result.data['page-seo'] || {};

          setHelpData({ 
            mainCategories, 
            parentCategories, 
            childCategories, 
            pageSEO 
          });
        } else {
          console.error('Error in response:', result);
        }
      } catch (error) {
        console.error('Error fetching help data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/get-help-category-content`, {
          params: {
            mainCategoryId,
            parentCategoryId,
            childCategoryId,
          },
        });

        console.log("API response:", response.data);

        if (response.data.success) {
          setContentData(response.data.data);
          // Update the document title with the child category title
          if (response.data.data['child-category']) {
            document.title = response.data.data['child-category'].title;
          }
        } else {
          setError('Failed to fetch content');
        }
      } catch (error) {
        setError('Error fetching help content');
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [mainCategoryId, parentCategoryId, childCategoryId]);

  if (error) {
    return <div className="hidden">{error}</div>;
  }

  if (!contentData) {
    return <div className="hidden">No content available.</div>;
  }

  return (
    <>
      <div className="static_header_inner">
        <div className="container-fluid">
          <div className="col-md-12">
            <div className="static_header_logo">
              <Link to="/help">
                <img src={staticlogo} alt="Logo" /> Community Guidelines
              </Link>

              <div className="search_btn_after_scroll hidden">
                <button
                  className="create_post_btn_area verify_btn search_btn_chat"
                  id="help_search_btn"
                >
                  <svg
                    className="heading_search_icon"
                    id="search_icon"
                    width={38}
                    height={38}
                    viewBox="0 0 38 38"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30.9109 17.3353C30.9109 24.7219 24.8843 30.7294 17.426 30.7294C9.96774 30.7294 3.94118 24.7219 3.94118 17.3353C3.94118 9.94871 9.96774 3.94118 17.426 3.94118C24.8843 3.94118 30.9109 9.94871 30.9109 17.3353Z"
                      stroke="#fff"
                      strokeWidth="3.88235"
                    />
                    <path
                      d="M33.6317 36.3769C34.392 37.1327 35.6211 37.1291 36.3769 36.3688C37.1327 35.6085 37.1291 34.3794 36.3688 33.6236L33.6317 36.3769ZM36.3688 33.6236L29.144 26.4412L26.4068 29.1945L33.6317 36.3769L36.3688 33.6236Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> 
      <section className="inner_static">
        <div className="container">
          <div className="row">    
            <div className="page_content_static ticket_container help_container_articles">
              <div className="left_menu_ticket_accordin">                          
                <div className="left_nav_bar_main">
                  <div className="accordion" id="accordionExample">
                    {helpData?.mainCategories?.length > 0 && helpData.mainCategories.map((mainCategory, index) => (
                      <div className="accordion-item" key={mainCategory.id}>
                        <h2 className="accordion-header" id={`heading${index}`}>
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse${index}`}
                            aria-expanded="false"
                            aria-controls={`collapse${index}`}
                          >
                            {mainCategory.title} 
                          </button>
                        </h2>
                        <div
                          id={`collapse${index}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={`heading${index}`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <ul>
                              {helpData.parentCategories
                                ?.filter(parent => parent['main-category-id'] === mainCategory.id)
                                .map(parent => (
                                  <li key={parent.id}>
                                    <Link to="/help">
                                      {parent.title}
                                    </Link>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>  
              </div>
              <div className="right_block_ticket help_block_right_main">
                <div className="breadcrumps">
                  <Link to="/help">Help Center</Link>
                  <div className="svg_icon_breadcrump">
                    <svg
                      width={54}
                      height={54}
                      viewBox="0 0 54 54"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 6.00001L37 27L16 48"
                        stroke="#8A96A3"
                        strokeWidth="7.46667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span className="like_link">{contentData['parent-category']?.title}</span>
                  <div className="svg_icon_breadcrump">
                    <svg
                      width={54}
                      height={54}
                      viewBox="0 0 54 54"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 6.00001L37 27L16 48"
                        stroke="#8A96A3"
                        strokeWidth="7.46667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span>{contentData['child-category']?.title}</span> 
                </div>
                <div className="help_block_right_main">
                  <div className="b-help-item">
                    <h3 className="ticket_headings help_single_heading">{contentData['child-category']?.title}</h3>
                    <div className="small_heading">
                      {/* Render the content as HTML */}
                      <div dangerouslySetInnerHTML={{ __html: contentData['child-category']?.content }} />
                    </div>
                    {contentData['related-articles'] && contentData['related-articles'].length > 0 && (
                      <div className="related_help_article">
                        <div className="b_help_article">
                          <h6 id="account">Related articles</h6>
                          <ul>
                            {contentData['related-articles'].map((article) => (
                              <li key={article.id}>
                                <Link to={`/help/${mainCategoryId}/${parentCategoryId}/${article.id}`}>
                                  {article.title}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div> 
        </div>    
      </section>
      <Footer />
    </>
  );
};

export default HelpContentPage;
